import Vue from 'vue';
import PlayerInfoRequestService from '../../services/playerInfo/player-info-request-service';
import LocalStorageService from '../../services/storage/local-storage-service';

/**
 * Vuex store - playeInfo module
 */
export const playerInfoModule = {
  state: {
    /**
     * This state proSSperty will contain payer related settings/ info
     */
    playerInfo: {
      cashout: false,
    },
  },
  mutations: {
    /**
     * Set player Info received from API
     * @param data player related settings/ information
     */
    setPlayerInfo(state, data) {
      LocalStorageService.set('pc', data.ca);
      Vue.set(state.playerInfo, 'cashout', data.ca);
      // LocalStorageService.set('pp', APP_SETTINGS.player.permissions);
    },
  },
  actions: {
    /**
     * method for getting player info
     */
    getPlayerInfo({ commit }) {
      const PlayerInfoRequest = new PlayerInfoRequestService();
      PlayerInfoRequest.execute((resp) => {
        commit('setPlayerInfo', resp.data);
      }, () => {
      });
    },
  },
};
